import React, { useEffect, useState } from "react";
import api from "~/services/api";

import CreateEditContent from "./CreateEditContent";
import VisualContent from "./VisualContent";

import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import { Colors } from "~/config/Colors";
import { SLCreateModal, SLEditModal } from "~/pages/Sistema/componentes/SistemaList";
import { useSelector } from "react-redux";

export default function MapaAlocacao() {
  const [data, setData] = useState([]);
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [clientes, setClientes] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const [idCliente, setIdCliente] = useState(0);

  const [idAnalista, setIdAnalista] = useState(0);
  const [atualizaMapa, setAtualizaMapa] = useState(true);
  const [anoReferencia, setAnoReferencia] = useState((new Date()).getFullYear());

  useEffect(() => {
    async function handleRequests() {
      api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));

      api.get("/signed/empresa/gestorprojeto/gerencia/analistas", { params: { ativo: 1 } })
        .then(response => setAnalistas(response.data));
    }

    handleRequests();
  }, []);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-pj"
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            topMain={false}
            informationPage={{
              title: "Mapa de Alocação",
              subTitle: "Crie e Gerencie os Mapas de Alocações",
              icone: "menu-projetos",
              menu: true,
            }}
            selects={[
              {
                list: clientes,
                value: "id",
                label: "nomeFantasia",
                outLabel: "Todos os Clientes",
                filter: "idCliente",
                onChange: (thisValue) => {
                  setIdCliente(thisValue);
                  setAtualizaMapa(true);
                }
              },
              {
                list: analistas,
                value: "id",
                label: "nome",
                outLabel: "Selecione analista",
                filter: "idAnalista",
                onChange: (thisValue) => {
                  setIdAnalista(thisValue);
                  setAtualizaMapa(true);
                }
              },
              {
                list: [{ id: "2025", nome: "2025" }, { id: "2024", nome: "2024" }],
                value: "id",
                label: "nome",
                filter: "ano",
                onChange: (thisValue) => {
                  setAnoReferencia(thisValue);
                  setAtualizaMapa(true);
                }
              },
            ]}
          >
            <CustomBodyContent {...{ idAnalista, idCliente, setIdAnalista, atualizaMapa, setAtualizaMapa, anoReferencia, setAnoReferencia }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
